var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6852 3.0918L2.50342 7.81907L7.67641 10.696L13.3086 6.46842L9.08108 12.1006L11.958 17.2736L16.6852 3.0918Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinSend);
export default __webpack_public_path__ + "static/media/linkedinSend.8f1a77e5.svg";
export { ForwardRef as ReactComponent };